<div class="description-container">
    <div class="title">
        <h2>{{ speciality.name | uppercase }}</h2>
    </div>
    <div class="description">
        <div class="des" [innerHTML]="speciality.description"></div>
    </div>
    <h3 [ngStyle]="{ 'text-align': 'start', width: '90%' }">{{ speciality.specialityType?.jobTitle }}</h3>
    <div class="doctor-container">
        @for (doctorSpeciality of speciality.doctorSpecialityList; track doctorSpeciality) {
            <div class="doctor">
                <div class="datas" [routerLink]="'/doctor/' + doctorSpeciality.doctor?.routerLink">
                    <div>
                        <img [src]="doctorSpeciality.doctor?.image" />
                        <span [ngStyle]="{ 'font-size': '13px' }">{{ doctorSpeciality.doctor?.name | uppercase }}</span>
                    </div>
                    <div class="consulting-hour-container">
                        <span>RENDELÉSI IDŐ:</span>
                        <div class="consult">
                            @for (consultingHour of doctorSpeciality.doctor?.doctorConsultingHourList; track consultingHour) {
                                <div>
                                    <div class="consulting">
                                        <span>{{ consultingHour.day }}:</span>
                                        @if (consultingHour.startTime !== null && consultingHour.endTime !== null) {
                                            <span> {{ consultingHour.startTime }} - {{ consultingHour.endTime }} </span>
                                        }
                                        @if (consultingHour.startTime === null && consultingHour.endTime === null) {
                                            <span> változó</span>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
